import { FormControl, FormGroup } from '@angular/forms';

type WarehouseLocalizationDetailsFormControls = {
  label: FormControl<string>;
  position: FormControl<number>;
};

export class WarehouseLocalizationDetailsForm {
  public constructor(
    public readonly label: string,
    public readonly position: number,
  ) {}
}

/* prettier-ignore */
export type WarehouseLocalizationDetailsFormGroup = FormGroup<WarehouseLocalizationDetailsFormControls>;

/* prettier-ignore */
export type WarehouseLocalizationDetailsControlsPossibleToHide = keyof Pick<WarehouseLocalizationDetailsFormControls, 'position'>;
